import { IconButton, SxProps, Tooltip } from "@mui/material";
import DownloadIcon from "assets/icons/DownloadIcon";
import { HTMLAttributeAnchorTarget } from "react";

interface DownloadFileButtonProps {
  href: string;
  target?: HTMLAttributeAnchorTarget;
  tooltipText?: string;
  disabled?: boolean;
  sx?: SxProps;
}

const DownloadFileButton = ({ href, tooltipText, ...rest }: DownloadFileButtonProps) => {
  return (
    <Tooltip title={tooltipText}>
      <span>
        <IconButton
          href={href}
          onClick={(e) => e.stopPropagation()}
          {...rest}>
          <DownloadIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default DownloadFileButton;
